class StickyHeader {
  constructor() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = true; // Update more options for sticky header later.
    this.headerBounds = {};
    this.offset = this.calculateOffset();

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('section-header--sticky');
    }

    this.currentScrollTop = this.header.offsetTop;
    this.preventReveal = false;

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.header.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
    this.onScrollHandler();
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  calculateOffset() {
    let previousSections = [];
    let prevElement = this.header.parentElement.previousElementSibling;

    while (prevElement) {
      if (prevElement.classList.contains('section')) {
        previousSections.push(prevElement);
      }
      prevElement = prevElement.previousElementSibling;
    }

    return previousSections.reduce((total, section) => {
      return total + section.offsetHeight;
    }, 0);
  }

  onScroll() {
    const scrollTop = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom + this.offset) {
      this.header.classList.add('section-header--is-sticky');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom + this.offset) {
      this.header.classList.add('section-header--is-sticky');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top + this.offset) {
      this.header.classList.remove('section-header--is-sticky');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('section-header--hidden', 'section-header--sticky');
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('section-header--sticky', 'animate');
    this.header.classList.remove('section-header--hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('section-header--hidden', 'section-header--sticky', 'animate');
  }
}

new StickyHeader();
